import React from "react";
import { Box } from "@mui/material";
import { convertArrayToString } from "../../../helpers/common";
import { iEventDetailCMS, iType } from "../../../types/eventTypes";
import "./eventOtherFieldValue.scss";

interface EventOtherFieldValueProps {
	presetValue?: string;
	otherText?: string;
	otherLabel?: string;
}

export const getCmsPresetDisplayValue = (
	items: Array<iType | undefined | false | null> | undefined,
	cms: iEventDetailCMS,
): string => {
	const value = convertArrayToString(items?.filter((item): item is iType => Boolean(item)), cms);
	return value && value !== "None" ? value : "";
};

const EventOtherFieldValue: React.FC<EventOtherFieldValueProps> = ({
	presetValue = "",
	otherText = "",
	otherLabel = "Other",
}) => {
	const trimmedPreset = presetValue.trim();
	const trimmedOther = otherText.trim();
	const hasOther = Boolean(trimmedOther);

	// No presets still shows a primary line ("None") so the "other" text always hangs off a
	// labelled value, keeping cuisines and courses visually identical.
	const primaryValue = trimmedPreset || "None";

	return (
		<Box className={`eventOtherFieldValue ${hasOther ? "eventOtherFieldValue--twoTier" : ""}`}>
			<p className="eventOtherFieldValue__primary">{primaryValue}</p>
			{hasOther && (
				<div className="eventOtherFieldValue__other">
					<span className="eventOtherFieldValue__otherLabel">{otherLabel}</span>
					<p className="eventOtherFieldValue__otherText">{trimmedOther}</p>
				</div>
			)}
		</Box>
	);
};

export default EventOtherFieldValue;
